import { render, staticRenderFns } from "./Traffic.vue?vue&type=template&id=399adf0d&scoped=true&"
import script from "./Traffic.vue?vue&type=script&lang=js&"
export * from "./Traffic.vue?vue&type=script&lang=js&"
import style0 from "./Traffic.vue?vue&type=style&index=0&id=399adf0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399adf0d",
  null
  
)

export default component.exports